"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4484],{

/***/ 94484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_scroll_parallax__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77776);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24036);
/* harmony import */ var _LayoutContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97537);
/* harmony import */ var _adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47322);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);











function Layout(props) {
  var block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(props);
  var extraAttributes = props.extraAttributes || {};

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
    event: {}
  }),
      customEvent = _useState[0],
      setCustomEvent = _useState[1];

  var hasSpotlightContestInChildren = function hasSpotlightContestInChildren() {
    var doc = block.getDocument();
    var hasContestInChildren = false;

    if (doc.fields && doc.fields.blocks) {
      doc.fields.blocks.forEach(function (block) {
        if (block.fields.code === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .LayoutConstants.zoneContestCode */ .GK.zoneContestCode || block.fields.code === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .LayoutConstants.zoneThankYouCode */ .GK.zoneThankYouCode) {
          hasContestInChildren = true;
        }
      });
    }

    return hasContestInChildren;
  };

  var hasContestInChildren = hasSpotlightContestInChildren();

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(hasContestInChildren),
      isContestVisible = _useState2[0],
      setIsContestVisible = _useState2[1];

  var onClickCallback = function onClickCallback(event) {
    if (event) {
      setCustomEvent({
        event: event.target
      });
    }
  };

  var layoutContextProvider = {
    onContestScrollDown: function onContestScrollDown() {
      setIsContestVisible(false);
    },
    onSliderScrollUpTop: function onSliderScrollUpTop() {
      setIsContestVisible(true);
    },
    hasContestInChildren: hasContestInChildren,
    isContestVisible: isContestVisible
  };
  var layoutClass = 'layout ';

  if (block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .LayoutConstants.classNames */ .GK.classNames)) {
    layoutClass = layoutClass + block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_6__/* .LayoutConstants.classNames */ .GK.classNames);
  }

  return hasContestInChildren ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: layoutClass,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_LayoutContext__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Provider */ .Z.Provider, {
      value: layoutContextProvider,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
        fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_scroll_parallax__WEBPACK_IMPORTED_MODULE_4__/* .ParallaxProvider */ .Xu, {
          children: block.renderChildBlocks({
            extraAttributes: extraAttributes
          }, onClickCallback, customEvent)
        })
      })
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: layoutClass,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_adapters_helpers_Loader__WEBPACK_IMPORTED_MODULE_8__["default"], {}),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_scroll_parallax__WEBPACK_IMPORTED_MODULE_4__/* .ParallaxProvider */ .Xu, {
        children: block.renderChildBlocks({
          extraAttributes: extraAttributes
        }, onClickCallback, customEvent)
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (Layout);

/***/ }),

/***/ 97537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var LayoutContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();
/* harmony default export */ __webpack_exports__["Z"] = (LayoutContext);

/***/ })

}]);